// extracted by mini-css-extract-plugin
export default {"userAndUserGroups":"WK4KHGZv6r"};